export enum ListingEvent {
    REFRESH = 'listing:refresh',
    UPDATE_PAGE = 'listing:updatePage',
    BATCH_CALLBACK = 'batchaction:callback',
}

export interface ListingUpdatePagePayload {
    listing: string;
    page?: number;
}

export interface ListingEventMap {
    [ListingEvent.REFRESH]: void;
    [ListingEvent.UPDATE_PAGE]: ListingUpdatePagePayload;
    [ListingEvent.BATCH_CALLBACK]: void;
}
